// extracted by mini-css-extract-plugin
export var emailBlockLink = "_od-0";